<template>
  <vs-popup class="customer-site-create-popup"
            id="order-change-popup"
            title="FORMULATIONS ITEM ORDER CHANGE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div>
        <vs-list>
          <draggable :list="raw_material_items" class="cursor-move">
            <transition-group>

              <vs-list-item class="flex items-center p-1 list-item mb-4" v-for="(item, index) in raw_material_items" :key="`${item.id}_${index}`"
                            :title="`${index + 1} : ${item.code || ''}
                            (${item.name || ''})`"
                            :subtitle="'Qty: '+item.quantity"
              >
                <feather-icon icon="AlignJustifyIcon" class="cursor-pointer ml-4 mr-6 mt-1 w-8" />
              </vs-list-item>

            </transition-group>
          </draggable>
        </vs-list>

        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button @click="onClickSaveOrder" button="submit" class="ml-auto mt-2 float-right">Save Order</vs-button>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const FormulationsRepository = RepositoryFactory.get('formulations');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import draggable from 'vuedraggable'

  function initialState() {
    return {
      open: false,
      raw_material_items: [],
      formulationId: ''
    }
  }

  export default {
    name: 'ItemOrderChangePopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(item_list, formulationId) {
        try {
          Object.assign(this.$data, initialState());
          this.formulationId = formulationId;
          Object.assign(this.raw_material_items, item_list);
          this.sortItems()
          this.open = true;
        } catch (error) {

        }
      },
      async onClickSaveOrder() {
        const vue = this;
        await this.$vs.loading({
          container: '#order-change-popup',
          scale: 0.45
        });
        try {
          const formatted_order = this.raw_material_items.map((n, index) => {
            n.manufacture_order = String(index + 1)
            return n
          });
          const raw_material_items = formatted_order.filter((x) => x.company_product_code && x.category).map((y) => {
            return {
              quantity: y.quantity,
              id: y.id,
              manufacture_order: y.manufacture_order
            }
          })
          const formulation_items = formatted_order.filter((x) => x.formulation_code && /^DIL-|^EXT-|^KEY-/.test(x.formulation_code)).map((y) => {
            return {
              quantity: y.quantity,
              id: y.id,
              manufacture_order: y.manufacture_order
            }
          })
          const carrier_items = formatted_order.filter((x) => x.code && x.is_3rd_party_rm).map((y) => {
            return {
              quantity: y.quantity,
              id: y.id,
              manufacture_order: y.manufacture_order,
              finished_quantity: y.is_liquid ? y.finished_quantity : 0
            }
          })

          await FormulationsRepository.updateFormulationsItems(this.formulationId, { raw_material_items: raw_material_items, formulation_items: formulation_items, carrier_items: carrier_items });
          this.showSuccessMessage('Formulation order Updated!');
          await vue.$parent.refreshData();
          vue.open = false
        } catch (e) {
          this.$vs.loading.close('#order-change-popup > .con-vs-loading');
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#order-change-popup > .con-vs-loading')
      },
      sortItems() {
        this.raw_material_items = this.raw_material_items.map((ob) => {
          return {
            ...ob,
            code: ob.category ? ob.category + '-' + ob.company_product_code : (ob.formulation_code ? ob.formulation_code : ob.code),
            name: ob.company_product_name ? ob.company_product_name : ob.name
          }
        }).sort((a, b) => {
          if (a.manufacture_order < b.manufacture_order) return -1
          return a.manufacture_order > b.manufacture_order ? 1 : 0
        })
      }
    },
    components: {
      draggable
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

  .list-item {
    transition: all 1s
  }

</style>
